import { acceptLegalAgreements } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  AcceptLegalAgreementsRequestT,
  DosespotIDPRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Accept the IDP legal agreements for the authenticated user.
 */
export async function fetchAcceptLegalAgreements(
  data: AcceptLegalAgreementsRequestT,
  signal?: AbortSignal
): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await acceptLegalAgreements(data, config);
  const result = lotusHealthZod.acceptLegalAgreementsResponse.parse(
    response.data
  ) as DosespotIDPRecordT;

  logger.info('dosespot.idp.acceptLegalAgreements', {
    source: 'entities/dosespot-idp/api',
    currentState: result.current_state,
  });

  return result;
}
